import React from 'react'
import { useOverflowObserver } from 'hooks/useOverflowObserver'
import styled from 'styled-components'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'

const StyledText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Text = ({ children }: { children: string }) => {
  const theme = useDisplayTheme()
  const { targetRef, isOverflowX } = useOverflowObserver()

  const handleTextRef = (
    setTooltipTriggerRef: React.Dispatch<React.SetStateAction<HTMLElement | null>>
  ) => (styledTextElement: HTMLElement) => {
    targetRef.current = styledTextElement
    setTooltipTriggerRef(styledTextElement)
  }

  return (
    <Tooltip
      mode={theme}
      enabled={isOverflowX}
      content={children}
      callbackRefCreator={handleTextRef}>
      <StyledText>{children}</StyledText>
    </Tooltip>
  )
}

export default Text
